<template>
    <div>
        <vx-card title="Manage Notifications">
            <vs-table id="notification-manage-table" stripe sort class="mt-8" :data="formatted_notification_list"
                :sst="true" @search="handleSearch" search>
                <template slot="thead">
                    <vs-th width="30%">FUNCTION</vs-th>
                    <vs-th width="30%" class="text-center">NOTIFICATION METHODS (CLICK TO ACTIVE/DE-ACTIVE)</vs-th>
                    <!-- <vs-th width="20%">NOTIFICATION STATUS</vs-th>
                    <vs-th width="20%">ACTION</vs-th> -->
                </template>

                <template slot-scope="{data}">
                    <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].name">
                            {{ data[indextr].name }}
                        </vs-td>

                        <vs-td>
                            <div class="vx-row text-center">
                                <vs-button class="mr-2" v-for="(type, index) in notification_types" :key="index"
                                    :type="data[indextr].preferences.delivery_method.includes(type.value) ? 'filled' : 'border'"
                                    :color="data[indextr].preferences.delivery_method.includes(type.value) ? 'success' : 'dark'"
                                    @click.stop="onClickNotificationType(tr.id, type.value)" size="small"
                                    >
                                    {{ type.label }}
                                </vs-button>
                            </div>
                        </vs-td>

                        <!-- <vs-td>
                            <vs-chip :color="data[indextr].preferences.is_enabled ? 'primary' : 'danger'" style="border-radius: 0"
                                transparent>
                                {{ data[indextr].preferences.is_enabled ? 'active' : 'disabled' }}
                            </vs-chip>
                        </vs-td>

                        <vs-td>
                            <div class="justify-start vx-row">
                                <vx-tooltip :text="tr.preferences.is_enabled ? 'Disable Notification' : 'Re Activate Notification'"
                                    position="top">
                                    <vs-button @click.stop="onClickSave(tr.id, tr)"
                                        class="ml-3" size="small" :color="tr.preferences.is_enabled ? 'danger' : 'primary'" type="border"
                                        icon-pack="feather" :icon="tr.preferences.is_enabled ? 'icon-x' : 'icon-check'">
                                        {{ tr.preferences.is_enabled ? 'Disable' : 'Activate' }}
                                    </vs-button>
                                </vx-tooltip>
                            </div>
                        </vs-td> -->

                    </vs-tr>
                </template>

            </vs-table>
        </vx-card>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
const StaffRepository = RepositoryFactory.get('staff');
import profile from '@/apis/profile.js'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
    name: 'NotificationManager',
    data() {
        return {
            notification_list: [],
            formatted_notification_list: [],
            disabled_notifications_ids: [],
            current_user: {},
            search_term: '',
            notification_types: [
                { value: 'database', label: 'In App' },
                { value: 'email', label: 'Email' },
            ]
        }
    },
    mixins: [ ErrorMessages ],
    async mounted() {
        await this.refreshData()
    },
    methods: {
        async refreshData() {
            await this.getCurrentUser()
            await this.fetchNotificationList()
        },
        async fetchNotificationList() {
            try {
                const { data } = (await StaffRepository.getListOfNotifications(this.current_user.id)).data
                this.notification_list = data
                this.notification_list = this.notification_list.map((x) => {
                    x.is_active = !this.disabled_notifications_ids.includes(x.id)
                    return x
                })
                this.handleSearch(this.search_term)
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        },
        async getCurrentUser() {
            try {
                const { data } = (await profile.getCurrentUser()).data
                this.current_user = data
                this.disabled_notifications_ids = data.disabled_notifications_ids
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        },
        async onClickSave(id,data) {
            await this.$vs.loading({
                container: '#notification-manage-table',
                scale: 0.45
            })
            try {
                const payload = { 
                    notification_manage_id: id,
                    is_enabled: !data.preferences.is_enabled,
                    delivery_method: data.preferences.delivery_method
                };
                await StaffRepository.disabledNotification(payload)
                await this.refreshData()
            } catch (error) {
                this.convertAndNotifyError(error)
            }
            this.$vs.loading.close('#notification-manage-table > .con-vs-loading')
        },
        async onClickNotificationType(id, type) {
            await this.$vs.loading({
                container: '#notification-manage-table',
                scale: 0.45
            })
            try {
                const notification = this.notification_list.find((x) => x.id === id)
                const delivery_method = notification.preferences.delivery_method
                if (delivery_method.includes(type)) {
                    delivery_method.splice(delivery_method.indexOf(type), 1)
                } else {
                    delivery_method.push(type)
                }
                const payload = {
                    notification_manage_id: id,
                    is_enabled: notification.preferences.is_enabled,
                    delivery_method: delivery_method
                }
                await StaffRepository.disabledNotification(payload)
                await this.refreshData()
            } catch (error) {
                this.convertAndNotifyError(error)
            }
            this.$vs.loading.close('#notification-manage-table > .con-vs-loading')
        },
        handleSearch(searching = '') {
            this.search_term = searching
            this.formatted_notification_list = this.notification_list.filter((x) => x.name.includes(this.search_term))
        },
    },
}
</script>
<style lang="">
    
</style>